import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useData } from '@hooks/useData';

export const MunicipalityLogo: FC = () => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        MunicipalityLogoAlt: t('municipality-logo.alt'),
    };

    return (
        <>
            {allSettings?.data?.municipalityLogo?.src && (
                <div className="align-self-center align-content-around py-4 py-lg-3 h-100">
                    <div className="d-flex justify-content-center h-100">
                        <img
                            style={{ height: 'max-content', alignSelf: 'center', maxWidth: '100%' }}
                            src={allSettings?.data.municipalityLogo?.src}
                            alt={translations.MunicipalityLogoAlt}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
